import { en } from './translations/en';
import { de } from './translations/de';
import { fr } from './translations/fr';

type TranslationTable = Record<string, string>;

export const translations: {
en: TranslationTable;
de: TranslationTable;
fr: TranslationTable;
} = {
en,
de,
fr
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof en | keyof typeof de | keyof typeof fr;

let currentLanguage: Language = 'de';

export const setLanguage = (lang: Language) => {
currentLanguage = lang;
};

export const t = (key: TranslationKey): string => {
return translations[currentLanguage][key] ?? translations.de[key] ?? translations.en[key] ?? String(key);
};
